import React from 'react';

interface RatingStarsProps {
  rating: number; // 0〜5（0は未入力）
  maxStars?: number;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

export const RatingStars: React.FC<RatingStarsProps> = ({ 
  rating, 
  maxStars = 5,
  className = '',
  size = 'medium'
}) => {
  // rating が 0 の場合は空の星を表示
  const filledStars = rating > 0 ? Math.round(rating) : 0;
  const emptyStars = maxStars - filledStars;

  const sizeClass = size === 'small' ? 'text-sm' : size === 'large' ? 'text-2xl' : 'text-lg';

  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {/* 塗りつぶし星 */}
      {Array.from({ length: filledStars }).map((_, index) => (
        <i key={`filled-${index}`} className={`ri-star-fill text-amber-400 ${sizeClass}`}></i>
      ))}
      {/* 空の星 */}
      {Array.from({ length: emptyStars }).map((_, index) => (
        <i key={`empty-${index}`} className={`ri-star-line text-gray-300 ${sizeClass}`}></i>
      ))}
    </div>
  );
};
